module.exports = __webpack_public_path__ + "files/4ce76b361cf1ea90ac8d3561b24e1abd.svg";


/*****************
 ** WEBPACK FOOTER
 ** ./non_npm_dependencies/google-fonts/fonts/lora-bolditalic-webfont.svg
 ** module id = 934
 ** module chunks = 0
 **/